import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import Carousel from "../ui_elements/Carousel";
import NewsHomeGrid from "../ui_elements/NewsHomeGrid";
import ButtonGrid, { ALL_BUTTONS } from "../ui_elements/ButtonGrid";
import MoreNewsButton from "../../assets/imgs/home/moreNewsButton.png";

const Home = () => {
  const [news, setNews] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch("/assets/json/news.json");

        if (!response.ok) {
          throw new Error(`Erro ao carregar JSON: ${response.statusText}`);
        }

        const data = await response.json();

        // Se o JSON contém um array diretamente
        if (Array.isArray(data)) {
          setNews(data); // Define os dados diretamente
        }
        // Se o JSON contém um objeto com a propriedade `news`
        else if (data.news && Array.isArray(data.news)) {
          setNews(data.news);
        } else {
          throw new Error("Estrutura de JSON inválida. Verifique o arquivo.");
        }
      } catch (err) {
        console.error(err);
        setError("Erro ao carregar os dados. Tente novamente mais tarde.");
      }
    };

    fetchNews();
  }, []);

  const headlines = news.slice(0, 5);
  const gridItems = news.slice(0, 3);

  const homeButtons = [
    ...ALL_BUTTONS.slice(0, 4),
    ALL_BUTTONS[ALL_BUTTONS.length - 1],
  ];

  const filteredButtons = searchQuery
    ? ALL_BUTTONS.filter(btn =>
        btn.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        btn.description.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : homeButtons;

  return (
    <div>
      {error && <p className="text-red-500">{error}</p>}

      <div className="flex flex-col items-center gap-3 py-4">
        <p className="text-sm font-semibold uppercase tracking-widest text-blue-900">
          Encontre o que você precisa
        </p>
        <div className="relative w-full max-w-2xl">
          <MagnifyingGlassIcon className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
          <input
            type="text"
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            placeholder="Pesquisar serviços e portais..."
            className="w-full border border-gray-300 rounded-xl pl-12 pr-4 py-3 text-base text-gray-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
          />
        </div>
      </div>

      {!searchQuery && (
        <div className="w-full mt-4">
          <div className="mt-4">
            {headlines.length > 0 && <Carousel items={headlines} />}
          </div>
        </div>
      )}

      {searchQuery ? (
        <div className="mt-4">
          {filteredButtons.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {filteredButtons.map((button, index) => (
                <a href={button.link} key={index}>
                  <div className={`w-full h-36 rounded-2xl ${button.bg_color} flex flex-col items-center justify-center`}>
                    <div className={`text-5xl mb-2 ${button.color}`}>{button.icon}</div>
                    <h5 className={`text-2xl font-bold ${button.color} mb-1`}>{button.title}</h5>
                    <span className={`text-lg font-medium ${button.color}`}>{button.description}</span>
                  </div>
                </a>
              ))}
            </div>
          ) : (
            <p className="text-gray-500 text-center py-8">Nenhum item encontrado para "{searchQuery}".</p>
          )}
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <div className="col-span-2 sm:col-span-3 lg:col-span-2">
            {gridItems.length > 0 && (
              <NewsHomeGrid items={gridItems}>
                <div className="relative group block bg-cover bg-center bg-gray-200 aspect-square h-50 md:h-80 lg:h-96 rounded-2xl overflow-hidden shadow-lg">
                  <div className="absolute inset-0 flex items-center justify-center">
                    <Link to="/noticias">
                      <img
                        className="h-24 md:h-36 lg:h-40"
                        src={MoreNewsButton}
                        alt="Ver todas as notícias"
                      />
                    </Link>
                  </div>
                </div>
              </NewsHomeGrid>
            )}
          </div>
          <div className="col-span-3 sm:col-span-3 lg:col-span-1">
            <ButtonGrid buttons={filteredButtons} />
          </div>
        </div>
      )}

      {/* Sessão da Localização */}
      <div className="mt-4">
        <div className="w-full flex justify-center rounded-2xl mb-4">
          <h2 className="text-2xl font-bold">Localização</h2>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15863.52868992719!2d-35.498164!3d-6.279218!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7b273f59c14526f%3A0x8c793875a8857433!2sPrefeitura%20Municipal%20de%20Serrinha!5e0!3m2!1spt-BR!2sus!4v1733919069798!5m2!1spt-BR!2sus"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google Maps"
        ></iframe>
      </div>
    </div>
  );
};

export default Home;
